// extracted by mini-css-extract-plugin
export default {"mainRoot":"layout-module--main-root--+HIQ+"};